module.exports = __webpack_public_path__ + "img/icon-shenheing.2d45c1d1.png";